module.exports = __webpack_public_path__ + "static/media/SolarCrest.ca520cb4.png";